import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';

function Laverage(props) {
    return (
        <div className="laverage_section p-100" style={{ backgroundColor: "#FCFCFC" }}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Custom App Development Process:</h2>
                        <p>Our process for music app development is unlike the processes we follow for other types of application development. That’s because, we know that this won’t right. Music apps are one of the most detailed oriented apps out there and users consistently engage with them throughout their day. Even a single lax feature or a dumb design flaw will lead to users dumping the app for good.</p>
                        <p><strong>This is exactly what we strive to differ from at Tekrevol</strong>. Our music app development process is top notch and designed specifically to ensure that only the best music apps are provided to clients and users a like.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
                        <div className="process_listing">
                            <div className="process_item">
                                <div className="number">01</div>
                                <h6>Ideation</h6>
                                <p>Conducting Product Discovery and Product Research</p>
                            </div>
                            <div className="process_item">
                                <div className="number">02</div>
                                <h6>Design</h6>
                                <p>Creating the UX Design, UI Design, and Branding</p>
                            </div>
                            <div className="process_item">
                                <div className="number">03</div>
                                <h6>Development</h6>
                                <p>Coding the app courtesy of our veteran engineers</p>
                            </div>
                            <div className="process_item">
                                <div className="number">04</div>
                                <h6>Quality Assurance</h6>
                                <p>Testing the app and making sure that everything works well</p>
                            </div>
                            <div className="process_item">
                                <div className="number">05</div>
                                <h6>Maintenance & Support</h6>
                                <p>Co-managing the app with your technology team </p>
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Laverage;